import React from 'react'
import { useRetorikStore } from '../../Contexts/RetorikContext'
import { useViewStore } from '../../Contexts/ViewContext'
import { useLocaleStore } from '../../Contexts/LocaleContext'
import { useSpeechStore } from '../../Contexts/SpeechContext'

import { Mode } from '../../../models/enums'

import { Toggle } from '../../Utils'
import LanguageButton from './LanguageButton'
import TutorialButton from './TutorialButton'
import HistoryButton from './HistoryButton'
import DisplaySubViews from '../ViewsDisplay/DisplaySubViews'

interface ParametersProps {
  handleBack?: () => void
}

const Parameters = ({ handleBack }: ParametersProps): JSX.Element => {
  const translation = useLocaleStore((state) => state.currentTranslations)
  const mode = useSpeechStore((state) => state.mode)
  const displaySubtitles = useRetorikStore((state) => state.displaySubtitles)
  const disableHistory = useRetorikStore((state) => state.disableHistory)
  const muted = useSpeechStore((state) => state.muted)
  const disableSound = useSpeechStore((state) => state.disableSound)
  const isMobile = useViewStore((state) => state.isMobile)
  const setMuted = useSpeechStore((state) => state.actions.setMuted)
  const setDisplaySubtitles = useRetorikStore((state) => state.actions.setDisplaySubtitles)

  const handleSoundChange = (val: boolean) => {
    setMuted(!val)
  }

  return (
    <React.Fragment>
      {/* Sound */}
      {!disableSound && <Toggle className='rf-py-3 large:rf-py-0' title={translation.common.sound} handleChange={handleSoundChange} defaultChecked={!muted} />}

      {/* Separating line only in mobile / widget modes */}
      {isMobile && <div className='rf-h-0 rf-w-full rf-border-t rf-border-t-menuBorder' />}

      {/* Subtitle */}
      {mode !== Mode.text && <Toggle className='rf-py-3 large:rf-py-0' title={translation.common.subtitle} handleChange={setDisplaySubtitles} defaultChecked={displaySubtitles} />}

      {/* Languages / Tutorial / History */}
      {isMobile && (
        <React.Fragment>
          <LanguageButton />
          <TutorialButton handleBack={handleBack} />
          {!disableHistory && <HistoryButton handleBack={handleBack} />}
          <DisplaySubViews handleClick={handleBack} />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default Parameters
